import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export const useRetrieveCardInput = () => {
  const [bookingId, setBookingId] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!bookingId || !password) {
      Swal.fire("Error", "Please fill in both fields", "error");
      return;
    }

    // Redirect to the decrypt-card route, passing the bookingId and password
    navigate(`/decrypt-card/${bookingId}`, { state: { password } });
  };

  return {
    bookingId,
    setBookingId,
    password,
    setPassword,
    handleSubmit,
  };
};
